export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST'
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS'
export const NOTIFICATION_LIST_ERROR = 'NOTIFICATION_LIST_ERROR'
export const NOTIFICATION_LIST_SET = 'NOTIFICATION_LIST_SET'

export const NOTIFICATION_READ_REQUEST = 'NOTIFICATION_READ_REQUEST'
export const NOTIFICATION_READ_SUCCESS = 'NOTIFICATION_READ_SUCCESS'
export const NOTIFICATION_READ_ERROR = 'NOTIFICATION_READ_ERROR'
export const NOTIFICATION_READ_SET = 'NOTIFICATION_READ_SET'

export const NOTIFICATION_CLEAR_REQUEST = 'NOTIFICATION_CLEAR_REQUEST'
export const NOTIFICATION_CLEAR_SUCCESS = 'NOTIFICATION_CLEAR_SUCCESS'
export const NOTIFICATION_CLEAR_ERROR = 'NOTIFICATION_CLEAR_ERROR'
export const NOTIFICATION_CLEAR_SET = 'NOTIFICATION_CLEAR_SET'

export const NOTIFICATION_CLEARALL_REQUEST = 'NOTIFICATION_CLEARALL_REQUEST'
export const NOTIFICATION_CLEARALL_SUCCESS = 'NOTIFICATION_CLEARALL_SUCCESS'
export const NOTIFICATION_CLEARALL_ERROR = 'NOTIFICATION_CLEARALL_ERROR'
export const NOTIFICATION_CLEARALL_SET = 'NOTIFICATION_CLEARALL_SET'

export const ALERT_LIST_REQUEST = 'ALERT_LIST_REQUEST'
export const ALERT_LIST_REQUEST_PAUSE = 'ALERT_LIST_REQUEST_PAUSE'
export const ALERT_LIST_SUCCESS = 'ALERT_LIST_SUCCESS'
export const ALERT_LIST_ERROR = 'ALERT_LIST_ERROR'
export const ALERT_LIST_SET = 'ALERT_LIST_SET'



// WEBPACK FOOTER //
// ./src/store/modules/notifications/notifications.type.js